import React, { FunctionComponent } from 'react'

import { TableFilterDropdownFooter } from '../TableFilterDropdownFooter/TableFilterDropdownFooter'

export interface TableFilterDropdownContainerProps {
  children?: React.ReactNode
  clearFilters?: () => void
  confirm: () => void
  close: () => void
  isSelected: boolean
  className?: string
}

export const TableFilterDropdownContainer: FunctionComponent<TableFilterDropdownContainerProps> =
  props => {
    return (
      <div
        className={`p-2 space-y-2 ${props.className || ''}`}
        onKeyDown={e => e.stopPropagation()}
      >
        {props.children}

        <TableFilterDropdownFooter
          clearFilters={props.clearFilters}
          confirm={props.confirm}
          close={props.close}
          isSelected={props.isSelected}
        />
      </div>
    )
  }
